import dayjs from 'dayjs';

import { utcDTStr2UTC } from 'utils/dateTime';
import { prizeRedeemDateLimitTypes } from 'config/promoPrizeTypes';
import {
    getPrizeRedeemExpiredInfo,
    prizeStatusLabels
} from 'client/components/Result/prizeList/getPrizeRedeemStatus';

export default function sortPrizes(items = []) {
    const categories = categorizePrize(items);
    return sortAllCategoriesAndMerge(categories);
}

function categorizePrize(items) {
    const categories = items.reduce(
        (obj, item) => {
            const {
                prizeSettings: {
                    redeemTimeType,
                    fillFormEndDate,
                    redeemStartDate,
                    redeemEndDate,
                    redeemWithinDays,
                    redeemWithinDateTime,
                    redeemWithinMonthsLastDay,
                    formId
                } = {},
                winnerStatus: { formAwardee, redeemed } = {},
                winnerCreatedAt
            } = item;
            const hasNotFillForm = Boolean(formId) && !formAwardee;
            const {
                hasStart: hasRedeemStart,
                hasExpired: hasRedeemExpired,
                endDateUtc: redeemEndDateUTC
            } = getPrizeRedeemExpiredInfo({
                redeemTimeType,
                redeemStartDate,
                redeemEndDate,
                redeemWithinDays,
                redeemWithinDateTime,
                redeemWithinMonthsLastDay,
                winnerCreatedAt
            });

            if (redeemed) {
                obj.redeemed.push(item);
            } else if (hasRedeemExpired) {
                obj.expired.push(item);
            } else if (hasNotFillForm) {
                if (!fillFormEndDate) {
                    obj.notFillForm.push(item);
                } else {
                    const hasFillFormDateAvailable = dayjs().isBefore(
                        dayjs(utcDTStr2UTC(fillFormEndDate))
                    );
                    if (hasFillFormDateAvailable) {
                        obj.notFillFormWithDateLimit.push(item);
                    } else {
                        obj.expired.push(item);
                    }
                }
            } else if (redeemTimeType === prizeRedeemDateLimitTypes.NO_LIMIT) {
                obj.general.push(item);
            } else {
                const newItem = {
                    ...item,
                    redeemEndDateUTC
                };
                if (!hasRedeemStart) {
                    obj.redeemableWithDateLimitHasNotStart.push(newItem);
                } else {
                    obj.redeemableWithDateLimit.push(newItem);
                }
            }
            return obj;
        },
        {
            notFillFormWithDateLimit: [],
            notFillForm: [],
            redeemableWithDateLimit: [],
            redeemableWithDateLimitHasNotStart: [],
            general: [],
            redeemed: [],
            expired: []
        }
    );
    return categories;
}
function sortAllCategoriesAndMerge({
    notFillFormWithDateLimit = [],
    notFillForm = [],
    redeemableWithDateLimit = [],
    redeemableWithDateLimitHasNotStart = [],
    general = [],
    redeemed = [],
    expired = []
} = {}) {
    notFillFormWithDateLimit = notFillFormWithDateLimit.map(item => ({
        ...item,
        statusLabel: prizeStatusLabels.HAS_NOT_FILL_FORM
    }));
    notFillFormWithDateLimit.sort((a, b) => {
        const aEndDate = a.prizeSettings.fillFormEndDate;
        const bEndDate = b.prizeSettings.fillFormEndDate;
        if (aEndDate === bEndDate) {
            return b.entryId - a.entryId;
        } else {
            return aEndDate < bEndDate ? -1 : 1;
        }
    });
    notFillForm = notFillForm.map(item => ({
        ...item,
        statusLabel: prizeStatusLabels.HAS_NOT_FILL_FORM
    }));
    notFillForm.sort((a, b) => b.entryId - a.entryId);
    redeemableWithDateLimit.sort((a, b) => a.redeemEndDateUTC - b.redeemEndDateUTC);
    redeemableWithDateLimitHasNotStart.sort((a, b) => a.redeemEndDateUTC - b.redeemEndDateUTC);
    general.sort((a, b) => b.entryId - a.entryId);
    redeemed = redeemed.map(item => ({
        ...item,
        statusLabel: prizeStatusLabels.REDEEMED
    }));
    redeemed.sort((a, b) => b.entryId - a.entryId);
    expired = expired.map(item => ({
        ...item,
        statusLabel: prizeStatusLabels.EXPIRED
    }));
    expired.sort((a, b) => b.entryId - a.entryId);

    return [
        ...notFillFormWithDateLimit,
        ...notFillForm,
        ...redeemableWithDateLimit,
        ...redeemableWithDateLimitHasNotStart,
        ...general,
        ...redeemed,
        ...expired
    ];
}
